import { useTranslation } from 'react-i18next';

import styles from '../../../../terminals/list/list.module.css';
import { TerminalListActiveFiltersProps } from './terminal-list-active-filters.type';

export const TerminalListActiveFilters = ({
  filters,
  onRemove,
}: TerminalListActiveFiltersProps) => {
  const { t } = useTranslation();

  const hasActiveFilters = Object.keys(filters).length > 0;

  if (!hasActiveFilters) {
    return null;
  }

  return (
    <div className={styles['filter-badges']}>
      {filters.payfac && (
        <button
          type="button"
          className={styles['filter-badge']}
          onClick={() => onRemove('payfac')}
        >
          {t('backoffice.terminalsFiltersPayfacLabel')}: {filters.payfac} ×
        </button>
      )}

      {filters.seller && (
        <button
          type="button"
          className={styles['filter-badge']}
          onClick={() => onRemove('seller')}
        >
          {t('backoffice.terminalsFiltersSellerLabel')}: {filters.seller} ×
        </button>
      )}

      {!!filters.serialNumbers?.length && (
        <button
          type="button"
          className={styles['filter-badge']}
          onClick={() => onRemove('serialNumbers')}
        >
          {t('backoffice.terminalsFiltersSerialsSelected', {
            count: filters.serialNumbers.length,
          })}{' '}
          ×
        </button>
      )}
    </div>
  );
};
